// app/redux/reducers/leaveBalanceReducer.js

import {
    SET_LEAVE_BALANCE_LOADING,
    CLEAR_LEAVE_BALANCE_MESSAGE,
    CHECK_BALANCE_SUCCESS,
    CHECK_BALANCE_FAIL,
    GET_USER_SOLDES_SUCCESS,
    GET_USER_SOLDES_FAIL,
    GET_ALL_COMPANY_SOLDES_SUCCESS,
    GET_ALL_COMPANY_SOLDES_FAIL,
    normalizeError, 
    CANCEL_LEAVE_REQUEST_SUCCESS, 
    CANCEL_LEAVE_REQUEST_FAIL,
    UPDATE_SOLDE_SUCCESS,
    UPDATE_SOLDE_FAIL,
    GET_ALL_MOVEMENTS_SUCCESS,
    GET_ALL_MOVEMENTS_FAIL,
    GET_USER_MOVEMENTS_SUCCESS,
    GET_USER_MOVEMENTS_FAIL,
} from "../actions/leaveBalanceActions";

const initialState = {
    loading: false,
    error: "",
    message: "",

    // Résultat de la vérification de solde
    balanceCheck: null, // { available, currentBalance, requestedDays, message }

    // Liste des soldes de l'utilisateur
    userSoldes: [], // [{ id, absenceTypeId, absenceTypeNom, soldeRestant, ... }]
    companySoldes: [],
 
    // Historique global RH et historique personnel doivent rester séparés :
    // les deux écrans peuvent être ouverts ou répondre dans un ordre différent.
    movements: [],
    userMovements: [],
};

const toStr = (x) => normalizeError(x, "");

export default function leaveBalanceReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LEAVE_BALANCE_LOADING:
            return { ...state, loading: !!action.payload };

        case CLEAR_LEAVE_BALANCE_MESSAGE:
            return { ...state, error: "", message: "" };

        // ========= CHECK BALANCE =========
        case CHECK_BALANCE_SUCCESS:
            return {
                ...state,
                balanceCheck: action.payload,
                error: "",
            };

        case CHECK_BALANCE_FAIL:
            return {
                ...state,
                balanceCheck: null,
                error: toStr(action.payload),
            };

        // ========= GET USER SOLDES =========
        case GET_USER_SOLDES_SUCCESS:
            return {
                ...state,
                userSoldes: action.payload || [],
                error: "",
            };

        case GET_USER_SOLDES_FAIL:
            return {
                ...state,
                userSoldes: [],
                error: toStr(action.payload),
            };

        // ========= GET ALL COMPANY SOLDES =========
        case GET_ALL_COMPANY_SOLDES_SUCCESS:
            return {
                ...state,
                companySoldes: action.payload || [],
                error: "",
            };

        case GET_ALL_COMPANY_SOLDES_FAIL:
            return {
                ...state,
                companySoldes: [],
                error: toStr(action.payload),
            };
        case CANCEL_LEAVE_REQUEST_SUCCESS:
            return {
                ...state,
                message: "Demande annulée avec succès",
                error: "",
            };

        case CANCEL_LEAVE_REQUEST_FAIL:
            return { ...state, error: toStr(action.payload) };

        case UPDATE_SOLDE_SUCCESS:
            return {
                ...state,
                message: "Solde mis à jour",
                error: ""
            };

        case UPDATE_SOLDE_FAIL:
            return {
                ...state,
                error: toStr(action.payload)
            };
 
        // ========= MOVEMENTS HISTORY =========
        case GET_USER_MOVEMENTS_SUCCESS:
            return {
                ...state,
                userMovements: action.payload || [],
                error: "",
            };

        case GET_USER_MOVEMENTS_FAIL:
            return {
                ...state,
                userMovements: [],
                error: toStr(action.payload),
            };

        case GET_ALL_MOVEMENTS_SUCCESS:
            return {
                ...state,
                movements: action.payload || [],
                error: "",
            };

        case GET_ALL_MOVEMENTS_FAIL:
            return {
                ...state,
                movements: [],
                error: toStr(action.payload),
            };

        default:
            return state;
    }
}
